<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.createUser')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <form role="form" @submit.prevent="submit()">

                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.setting.createUser')}}</div>
                            <button class="btn btn-primary float-right">{{$t('button.save')}}</button>
                        </div>

                        <div class="card-body">

                            <div class="form-group">
                                <label>{{$t('form.setting.fullName')}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="user.name"    :class="{ 'is-invalid': $v.user.name.$error }">
                                <div class="invalid-feedback" v-if="!$v.user.name.required">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.email')}}<span class="text-danger">*</span></label>
                                <input type="email" class="form-control" v-model="user.email" :class="{ 'is-invalid': $v.user.email.$error }">

                                 <div class="invalid-feedback" v-if="!$v.user.email.required">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.username')}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="user.username" :class="{ 'is-invalid': $v.user.username.$error }">

                                <div class="invalid-feedback" v-if="!$v.user.username.required">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.password')}}<span class="text-danger">*</span></label>
                                <input type="password" class="form-control" v-model="user.password" :class="{ 'is-invalid': $v.user.password.$error }">

                                <div class="invalid-feedback" v-if="!$v.user.password.required">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.confirmPassword')}}<span class="text-danger">*</span></label>
                                <input type="password" class="form-control" v-model="user.password_confirmation" :class="{ 'is-invalid': $v.user.password_confirmation.$error }">

                                 <div class="invalid-feedback" v-if="!$v.user.password_confirmation.required">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.partner')}}</label>
                                <v-select label="PartnerCode" :options="partners" v-model="user.partner_id"
                                    :reduce="partners => partners.PartnerID">
                                </v-select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.staff')}}</label>
                                <v-select label="FullName" :options="staff" v-model="user.staff_id"
                                    :reduce="staff => staff.ID">
                                </v-select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.status')}}</label>
                                <select class="form-control" v-model="user.status">
                                    <option value="1">{{$t('form.setting.enable')}}</option>
                                    <option value="0">{{$t('form.setting.disable')}}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.authentication')}}<span class="text-danger">*</span></label>
                                <select class="form-control" v-model="user.authenticate_by">
                                    <option value="ldap">{{$t('form.setting.ldap')}}</option>
                                    <option value="local">{{$t('form.setting.local')}}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.role')}}<span class="text-danger">*</span></label>
                                <v-select @input="onChangeRoles" v-model="selectedRoles" label="name" :options="roles" multiple :class="{ 'is-invalid': rolesError }"></v-select>
                                <div class="invalid-feedback" v-if="rolesError">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.google2FAMode')}}</label>
                                <select class="form-control" v-model="user.google2fa_mode">
                                    <option value="disabled">{{$t('form.setting.disabled')}}</option>
                                    <option value="optional">{{$t('form.setting.optional')}}</option>
                                    <option value="enforced">{{$t('form.setting.enforced')}}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
 import {
        required,
        minLength,
        maxLength,
        sameAs,
        decimal,
        alpha,
        numeric
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                user: {
                    id: '',
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    authenticate_by: 'local',
                    partner_id: null,
                    staff_id: null,
                    google2fa_mode: '',
                    status: null,
                },

                selectedRoles: [],
                roles: [],
                rolesError: false,
                partners: [],
                staff: []
            }
        },
        validations: {
            user: {  
                 name: {
                    required,
                    maxLength: maxLength(255)
                }, 
                username:{
                        required,
                         maxLength: maxLength(255)
                },
                email:{
                        required,
                         maxLength: maxLength(255)
                    },

                password: {
                        required,
                        minLength:minLength(8),
                        containsUppercase: function(value) {
                        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/.test(value)
                        },
                        
                    },
                    password_confirmation: {
                        required,
                        minLength:minLength(8),
                        sameAsPassword:sameAs('password')
                    },                 
               
            }
        },

        mounted() {
            if (!this.permissions.createSettingsUsers) {
                this.$router.push('/');
                return;
            }

            this.getInitialData();
        },

        methods: {

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },
            onChangeRoles(){
                if(this.selectedRoles.length == 0){
                    this.rolesError = true;
                }else{
                    this.rolesError = false;
                }
            },
            submit() {
                if(this.selectedRoles.length == 0){
                    this.rolesError = true;
                }else{
                    this.rolesError = false;
                }

               this.$v.$touch();
                // apply vue validation


                if (this.$v.$invalid) {
                let errorMsg = '';

                ;

                if(this.$v.user.name.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.fullName'): this.$t('form.setting.fullName');
                }

                 if(this.$v.user.username.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.username'): this.$t('form.setting.username');
                }

                if(this.$v.user.email.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.email'): this.$t('form.setting.email');
                }


                if(this.$v.user.password.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.password'): this.$t('form.setting.password');
                }

                if(this.$v.user.password_confirmation.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.confirmPassword'): this.$t('form.setting.confirmPassword');
                }

                if(this.user.password != this.user.password_confirmation){
                    errorMsg = errorMsg ? errorMsg +": "+this.$t('form.setting.passwordNotMatch'): this.$t('form.setting.passwordNotMatch');
                } 

                if(this.selectedRoles.length == 0){
                      errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.role'):this.$t('form.setting.role');
                }

                 this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return; 
                }
                
                 
                this.alert = false;
                this.isLoading = true;

                let formData = new FormData();

                this.selectedRoles.forEach((role) => formData.append('roles[]', role.id));

                formData.append('user', JSON.stringify(this.user));

                axios
                    .post('/api/users', formData)
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'UserIndex'
                                });
                            }, 2000);
                        }

                        this.isLoading = false;
                    }).catch(error => {
                        let errorMsg = '';
                        this.isLoading = false;
                        if(error.response.data.errors){
                        const objectArray = Object.entries(error.response.data.errors);
                        var index=1;
                        objectArray.forEach(([key, value]) => {
                        for(var j=0;j<error.response.data.errors[key].length;j++){
                            errorMsg = error.response.data.errors[key][0]
                            this.showAlert(errorMsg, 'danger');
                            }
                          });
                        }
                        else
                        {
                            this.showAlert(error.response.data.message,'danger');
                        }
                    })
            },

            getInitialData() {
                axios
                    .get('/api/users/initial-data')
                    .then((response) => {
                        this.roles = response.data.roles;
                        this.partners = response.data.partners;
                        this.staff = response.data.staff;

                        this.staff.map(s => s.FullName = `${s.FirstName} ${s.LastName}`);
                    })
                    .catch(error => console.log(error.response));
            }
        }
    }

</script>
